import { useState } from "react";
import {
  useProgram, ProgramGate, ProgramLoading, NeedAuth, ProgramShell, useProgress, ProgressBar,
  CompleteButton, Block, Paragraphs, PromptList, AccordionItem,
} from "@/pages/programs/_gate";

const muted = "text-sm sm:text-base text-muted-foreground leading-relaxed";

function SectionBody({ s }) {
  return (
    <>
      <Block label="Teaching"><Paragraphs text={s.body} /></Block>
      <Block label="Workbook exercises" accent><PromptList items={s.exercises} numbered /></Block>
      <Block label="Reflection prompts"><PromptList items={s.reflection_prompts} /></Block>
      <Block label="What this looks like in real life">
        <Paragraphs text={s.example} className={`${muted} italic`} />
      </Block>
      <Block label="Common pitfall"><p className={muted}>{s.pitfall}</p></Block>
      <Block label="Lock it in"><p className="font-serif text-base sm:text-lg leading-relaxed">{s.lock_in}</p></Block>
    </>
  );
}

export default function TimelineWorkbook() {
  const { loading, data, locked, needsAuth } = useProgram("/programs/timeline-workbook");
  const { done, toggle, isDone } = useProgress("timeline_workbook");
  const [open, setOpen] = useState(null);

  if (needsAuth) return <NeedAuth />;
  if (loading) return <ProgramLoading />;
  if (locked) return <ProgramGate productKey="timeline_workbook" priceLabel="the Timeline Shift Workbook · $55" purchaseCta="Unlock for $55" />;
  if (!data) return <ProgramLoading />;

  const current = open ?? (data.sections.find((s) => !isDone(s.slug))?.slug ?? "");

  const complete = (slug, i) => {
    const wasDone = isDone(slug);
    toggle(slug);
    if (!wasDone) setOpen(data.sections[i + 1]?.slug ?? "");
  };

  return (
    <ProgramShell eyebrow={`Workbook · ${data.sections.length} sections`} title={data.title}>
      <p className="text-muted-foreground max-w-2xl mb-8 leading-relaxed">
        Each section has a teaching, hands-on exercises, reflection prompts, a real-life example, the pitfall to watch for, and a lock-in step. Keep a notebook beside you. Don't rush — this isn't meant to be read, it's meant to be worked.
      </p>
      <ProgressBar done={done.length} total={data.sections.length} label="sections" />
      <div className="space-y-3">
        {data.sections.map((s, i) => (
          <AccordionItem
            key={s.slug}
            id={`workbook-section-${s.slug}`}
            number={String(i + 1).padStart(2, "0")}
            eyebrow={`Section ${i + 1}`}
            title={s.title}
            open={current === s.slug}
            done={isDone(s.slug)}
            onToggle={() => setOpen(current === s.slug ? "" : s.slug)}
          >
            <SectionBody s={s} />
            <CompleteButton done={isDone(s.slug)} onClick={() => complete(s.slug, i)} testId={`workbook-section-${s.slug}-complete`} />
          </AccordionItem>
        ))}
      </div>
    </ProgramShell>
  );
}
